<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-next`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.2 4.404l24 17.996a2 2 0 010 3.2l-24 17.996c-1.318.99-3.2.049-3.2-1.6V6.004c0-1.648 1.882-2.588 3.2-1.6zm27.8-.4a1 1 0 011 1v37.992a1 1 0 01-1 1h-2a1 1 0 01-1-1V5.004a1 1 0 011-1h2zm-27 5.998v27.996L30.667 24 12 10.002z"/></svg>
</template>
<script>

export default {
  name: 'IconNext',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
